import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  ViewEncapsulation,
} from "@angular/core";
import Highcharts from "highcharts";
import { ChartPlotterService } from "../chart-plotter.service";
import { ChartPlotterDataService } from "../chart-plotter-data.service";
import { VAIconRegistryService, infoCircle } from "@va/core-library/icons";

@Component({
  selector: "app-chart-data-table",
  templateUrl: "./chart-data-table.component.html",
  styleUrls: ["./chart-data-table.component.scss"],
  encapsulation: ViewEncapsulation.None,
  host: { class: "chart-data-table-component" },
})
export class ChartDataTableComponent implements OnInit {
  @Input() dataToUse: any;
  @Input() chartType: string;
  @Output() chartDataSet: EventEmitter<any> = new EventEmitter();

  chartDataTable: any;
  headers: Array<any>;
  rowHeader: Array<any>;
  precision: string;
  loading = false;
  titleHeader = "";
  showError = false;
  errorMessage = "";
  constructor(
    private service: ChartPlotterService,
    private dataService: ChartPlotterDataService,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([infoCircle]);
  }

  ngOnInit() {
    this.headers = [];
    this.chartDataTable = [];
    this.rowHeader = [];
    this.loading = true;
    //check data present if yes call setTabledata else call getData
    if (this.dataToUse.tableData) {
      this.setTableData();
    } else {
      this.getData();
    }
  }
  ngOnChanges(changes: SimpleChanges) {
    if (
      (!changes.dataToUse.firstChange &&
        changes.dataToUse.previousValue.period !==
          changes.dataToUse.currentValue.period) ||
      (changes.dataToUse.previousValue &&
        ((changes.dataToUse.previousValue.selectedRevisionSources &&
          changes.dataToUse.previousValue.selectedRevisionSources.toString() !==
            changes.dataToUse.currentValue.selectedRevisionSources.toString()) ||
          (changes.dataToUse.previousValue.selectedSurpriseSources &&
            changes.dataToUse.previousValue.selectedSurpriseSources.toString() !==
              changes.dataToUse.currentValue.selectedSurpriseSources.toString()) ||
          (changes.dataToUse.previousValue.selectedDistributionRangeSources &&
            changes.dataToUse.previousValue.selectedDistributionRangeSources.toString() !==
              changes.dataToUse.currentValue.selectedDistributionRangeSources.toString()) ||
          (changes.dataToUse.previousValue.tickerList &&
            changes.dataToUse.previousValue.tickerList.toString() !==
              changes.dataToUse.currentValue.tickerList.toString())))
    ) {
      this.headers = [];
      this.chartDataTable = [];
      this.rowHeader = [];
      this.loading = true;
      //check data present if yes call setTabledata else call getData
      if (this.dataToUse.tableData) {
        this.setTableData();
      } else {
        this.getData();
      }
    }
  }

  tableValueFormat(val) {
    const pointObj = {
      value: val,
      class: "",
    };
    if (!val || val === "NA" || val === "") {
      return pointObj;
    }
    if (parseFloat(val) < 0) {
      val = Math.abs(val);
      pointObj.value = val;
      pointObj.class = "error-color";
    } else {
      pointObj.value = val;
    }

    return pointObj;
  }
  setTableData() {
    if (!this.dataToUse.tableData.precision) {
      this.dataToUse.tableData.precision = 2;
    }
    this.precision = `1.${this.dataToUse.tableData.precision}-${this.dataToUse.tableData.precision}`;
    this.titleHeader = "";
    switch (this.chartType) {
      case "distribution-analysis":
        if (this.dataToUse.tableData.Value.x.length > 0) {
          this.headers = [...this.dataToUse.tableData.Value.x];
          this.chartDataTable = [];

          const unitSymbol =
            this.dataToUse.tableData.unit === "%" ? "bps" : "%";
          const tableData =
            this.dataToUse.tableData.Value.data.broker_value_list;
          const firstRow = [
            ...tableData.map((v) => {
              return this.tableValueFormat(v[3]);
            }),
          ];
          const secondRow = [
            ...tableData.map((v) => {
              return this.tableValueFormat(v[1]);
            }),
          ];
          const thirdRow = [
            ...tableData.map((v) => {
              return this.tableValueFormat(v[2]);
            }),
          ];
          this.rowHeader = [
            `${this.dataToUse.tableData.parameter_name} ( ${this.dataToUse.tableData.display_unit} )`,
            `Deviation ( ${this.dataToUse.tableData.display_unit} )`,
            `Deviation ( ${unitSymbol} )`,
          ];
          this.chartDataTable = [firstRow, secondRow, thirdRow];
        } else {
          this.showError = true;
          this.loading = false;
          this.errorMessage = "No data available";
          return;
        }
        break;
      case "distribution-range":
        if (this.dataToUse.tableData.Value.x.length > 0) {
          this.headers = [...this.dataToUse.tableData.Value.x];
          this.chartDataTable = [];

          const tableData = this.dataToUse.tableData.Value.data;
          const firstRow = [
            ...tableData.lowhigh.map((v) => {
              return this.tableValueFormat(v[2]);
            }),
          ];
          const secondRow = [
            ...tableData.normal.map((v) => {
              return this.tableValueFormat(v[1]);
            }),
          ];
          const thirdRow = [
            ...tableData.lowhigh.map((v) => {
              return this.tableValueFormat(v[1]);
            }),
          ];
          this.rowHeader = [
            `High ( ${this.dataToUse.tableData.display_unit} )`,
            `Consensus ( ${this.dataToUse.tableData.display_unit} )`,
            `Low ( ${this.dataToUse.tableData.display_unit} )`,
          ];
          this.chartDataTable = [firstRow, secondRow, thirdRow];
          const srcValueMapping = {};
          Object.keys(tableData).forEach((src) => {
            if (src !== "lowhigh" && src !== "normal") {
              const periodValue = {};
              tableData[src].forEach((element) => {
                periodValue[element[0]] = this.tableValueFormat(element[1]);
              });
              srcValueMapping[src] = periodValue;
            }
          });
          Object.keys(srcValueMapping).forEach((src) => {
            this.rowHeader.push(
              `${src} ( ${this.dataToUse.tableData.display_unit} )`,
            );
            const rowData = [];
            this.headers.forEach((period) => {
              srcValueMapping[src][period]
                ? rowData.push(srcValueMapping[src][period])
                : rowData.push("");
            });
            this.chartDataTable.push(rowData);
          });
        } else {
          this.showError = true;
          this.loading = false;
          this.errorMessage = "No data available";
          return;
        }
        break;
      case "trend-bar":
        if (this.dataToUse.tableData.Value.x.length > 0) {
          this.headers = [...this.dataToUse.tableData.Value.x];
          this.chartDataTable = [];
          const unitSymbol =
            this.dataToUse.tableData.unit === "%" ? "bps" : "%";
          const tableData = this.dataToUse.tableData.Value.data;
          const firstRow = [
            ...tableData.normal.map((v) => {
              return this.tableValueFormat(v[1]);
            }),
          ];
          const secondRow = [
            ...tableData.yoy.map((v) => {
              return this.tableValueFormat(v[1]);
            }),
          ];
          this.rowHeader = [
            `${this.dataToUse.tableData.parameter_name}  ( ${this.dataToUse.tableData.display_unit} )`,
            `YoY Growth ( ${unitSymbol} )`,
          ];
          const rowArr = [firstRow];
          if (secondRow && secondRow.length) {
            rowArr.push(secondRow);
          }
          this.chartDataTable = rowArr;
        } else {
          this.showError = true;
          this.loading = false;
          this.errorMessage = "No data available";
          return;
        }
        break;
      case "revision-daily":
      case "revision-monthly":
      case "revision-dailypeers":
      case "revision-monthlypeers":
        this.titleHeader = "Revision Date";
        this.createRevisionTableData();
        break;

      case "surprise-line":
      case "surprise-analysis": {
        if (Object.keys(this.dataToUse.tableData.data).length === 0) {
          this.showError = true;
          this.loading = false;
          this.errorMessage = "No data available";
          return;
        }
        let noData = true;
        const keys = Object.keys(this.dataToUse.tableData.data);
        for (let i = 0; i < keys.length; i++) {
          if (this.dataToUse.tableData.data[keys[i]].x.length > 0) {
            noData = false;
            break;
          }
        }
        if (noData) {
          this.showError = true;
          this.loading = false;
          this.errorMessage = "No data available";
          return;
        }
        const { tableData } = this.dataToUse;
        const seriesData = this.formatSurpriseColData(tableData);
        this.createSurpriseTableData(tableData, seriesData);
        break;
      }

      case "revision-analysis":
        if (this.dataToUse.tableData.x_axis.length > 0) {
          let noData = true;
          const keys = Object.keys(this.dataToUse.tableData.data);
          for (let i = 0; i < keys.length; i++) {
            if (this.dataToUse.tableData.data[keys[i]].length > 0) {
              noData = false;
              break;
            }
          }
          if (noData) {
            this.showError = true;
            this.loading = false;
            this.errorMessage = "No data available";
            return;
          }
          this.headers = [...this.dataToUse.tableData.x_axis];
          this.chartDataTable = [];
          const tableData = this.dataToUse.tableData.data;
          const firstRow = [
            ...tableData["Preq"].map((v) => {
              return this.tableValueFormat(v[1]);
            }),
          ];
          const sourceName = Object.keys(tableData).find(
            (sname) => sname !== "Preq",
          );
          const secondRow = [
            ...tableData[sourceName].map((v) => {
              return this.tableValueFormat(v[1]);
            }),
          ];
          this.rowHeader = ["PreQ", "Current"];
          this.chartDataTable = [firstRow, secondRow];
        } else {
          this.showError = true;
          this.loading = false;
          this.errorMessage = "No data available";
        }
        break;
      default:
    }
    this.loading = false;
  }
  setDisplayData(chartData) {
    const displayData: {
      lineItemName: string;
      magnitude: string;
      currency?: string | null;
      firstEstimatedPeriod?: string | null;
      firstEstimatedQuarter?: string | null;
      stdDev?: number | null;
      consensusValue?: number | null;
      tableData?: any;
    } = {
      lineItemName: "",
      magnitude: "",
    };
    displayData.lineItemName = chartData.parameter_name;
    displayData.magnitude = chartData.display_unit;
    displayData.currency = chartData.currency;
    if (chartData.first_estimated_year) {
      displayData.firstEstimatedPeriod = chartData.first_estimated_year;
      displayData.firstEstimatedQuarter = chartData.first_estimated_quarter;
    }
    if (chartData.deviation) {
      displayData.stdDev = chartData.deviation;
      displayData.consensusValue = this.service.getFormattedValue(
        chartData,
        chartData.consensusvalue,
      );
    }
    displayData.tableData = chartData;
    this.chartDataSet.emit(displayData);
  }
  getData() {
    this.showError = false;
    this.errorMessage = "";
    switch (this.chartType) {
      case "multi-company-revision":
        this.dataService
          .getMultiCompanyRevisionChartData(this.dataToUse)
          .subscribe(
            (response) => {
              if (response.status === "error") {
                this.showError = true;
                this.loading = false;
                throw Error(
                  "getMultiCompanyRevisionChartData throws status error",
                );
              }
              response["percentChange"] = this.dataToUse.percentChange;
              this.dataToUse.tableData = response;
              this.setTableData();
              this.setDisplayData(response);
            },
            (err) => {
              throw Error(err);
            },
          );
        break;

      case "distribution-analysis":
        this.dataService
          .getDistributionAnalysisChartData(this.dataToUse)
          .subscribe(
            (response) => {
              if (response.status === "error") {
                this.showError = true;
                throw Error(
                  "getDistributionAnalysisChartData throws status error",
                );
              }
              this.dataToUse.tableData = response;
              this.setTableData();
              this.setDisplayData(response);
            },
            (err) => {
              throw Error(err);
            },
          );
        break;
      case "distribution-range":
        this.dataService
          .getDistributionRangeChartData(this.dataToUse)
          .subscribe(
            (response) => {
              if (response.status === "error") {
                this.showError = true;
                this.loading = false;
                throw Error(
                  "getDistributionRangeChartData throws status error",
                );
              }
              this.dataToUse.tableData = response;
              this.setTableData();
              this.setDisplayData(response);
            },
            (err) => {
              throw Error(err);
            },
          );
        break;
      case "trend-bar":
        this.dataService.getTrendBarChartData(this.dataToUse).subscribe(
          (response) => {
            if (response.status === "error") {
              this.showError = true;
              this.loading = false;
              throw Error("getTrendBarChartData throws status error");
            }
            this.dataToUse.tableData = response;
            this.setTableData();
            this.setDisplayData(response);
          },
          (err) => {
            throw Error(err);
          },
        );
        break;
      case "revision-daily":
      case "revision-monthly":
      case "revision-dailypeers":
      case "revision-monthlypeers":
        this.dataToUse.revisionVal =
          this.chartType === "revision-daily" ||
          this.chartType === "revision-dailypeers"
            ? "1"
            : "2";
        this.dataToUse["isRevisionPeers"] =
          this.chartType === "revision-dailypeers" ||
          this.chartType === "revision-monthlypeers"
            ? true
            : false;
        this.dataService.getRevisionChartData(this.dataToUse).subscribe(
          (response) => {
            if (response.status === "error") {
              this.showError = true;
              this.loading = false;
              throw Error("getRevisionChartData throws status error");
            }
            this.dataToUse.tableData = response;
            this.setTableData();
            this.setDisplayData(response);
          },
          (err) => {
            throw Error(err);
          },
        );
        break;
      case "revision-analysis":
        this.dataService.getRevisionAnalysisChartData(this.dataToUse).subscribe(
          (response) => {
            if (response.status === "error") {
              this.showError = true;
              this.loading = false;
              throw Error("getRevisionAnalysisChartData throws status error");
            }
            this.dataToUse.tableData = response;
            this.setTableData();
            this.setDisplayData(response);
          },
          (err) => {
            throw Error(err);
          },
        );
        break;
      case "surprise-analysis":
        this.dataService.getSurpriseAnalysisChartData(this.dataToUse).subscribe(
          (response) => {
            if (response.status === "error") {
              this.showError = true;
              this.loading = false;
              throw Error("getSurpriseAnalysisChartData throws status error");
            }
            this.dataToUse.tableData = response;
            this.setTableData();
            this.setDisplayData(response);
          },
          (err) => {
            throw Error(err);
          },
        );
        break;
      case "surprise-line":
        this.dataService.getSurpriseLineChartData(this.dataToUse).subscribe(
          (response) => {
            if (response.status === "error") {
              this.showError = true;
              this.loading = false;
              throw Error("getSurpriseLineChartData throws status error");
            }
            this.dataToUse.tableData = response;
            this.setTableData();
            this.setDisplayData(response);
          },
          (err) => {
            throw Error(err);
          },
        );
        break;
      default:
        break;
    }
  }

  createRevisionTableData() {
    if (Object.keys(this.dataToUse.tableData.data).length === 0) {
      this.showError = true;
      this.loading = false;
      this.errorMessage = "No data available";
      return;
    }
    let noData = true;
    const keys = Object.keys(this.dataToUse.tableData.data);
    for (let i = 0; i < keys.length; i++) {
      if (this.dataToUse.tableData.data[keys[i]].length > 0) {
        noData = false;
        break;
      }
    }
    if (noData) {
      this.showError = true;
      this.loading = false;
      this.errorMessage = "No data available";
      return;
    }
    this.rowHeader = [];
    this.chartDataTable = [];
    // let dateList = [];
    const uniqueDateSet = new Set<number>();
    const sourceWiseMap = {};
    for (const source in this.dataToUse.tableData.data) {
      const rowHeaderName = `${source} ( ${this.dataToUse.tableData.display_unit} )`;
      //avoid sources with no data using below condition.
      if (this.dataToUse.tableData.data[source].length > 0) {
        this.rowHeader.push(rowHeaderName);
        sourceWiseMap[rowHeaderName] = {};
        this.dataToUse.tableData.data[source].forEach((rev) => {
          if (
            (this.dataToUse.tableData.earnings_date_w_rev &&
              this.dataToUse.tableData.earnings_date_w_rev.includes(rev[0])) ||
            !this.dataToUse.tableData.earnings_date ||
            (this.dataToUse.tableData.earnings_date &&
              !this.dataToUse.tableData.earnings_date.includes(rev[0]))
          ) {
            const dateSplits = rev[0].split("-");
            const revDate = new Date(
              Number(dateSplits[0]),
              Number(dateSplits[1]) - 1,
              Number(dateSplits[2]),
            ).getTime();

            uniqueDateSet.add(revDate);
            sourceWiseMap[rowHeaderName][revDate] = this.tableValueFormat(
              rev[1],
            );
          }
        });
      }
    }

    let uniqueDates = Array.from(uniqueDateSet);
    uniqueDates = uniqueDates.sort();
    this.headers = uniqueDates.map((date) => {
      return Highcharts.dateFormat("%d-%b-%Y", date);
    });

    //loop through series for each source
    this.rowHeader.forEach((source) => {
      const rowArr = [];
      for (let i = 0; i < uniqueDates.length; i++) {
        const date = uniqueDates[i];
        // if (this.dataToUse.tableData.earnings_date.includes(date)) continue;
        const revData = sourceWiseMap[source][date];
        //if current source doesnt have revision data for this date
        if (revData === undefined) {
          rowArr.push({});
        } else {
          rowArr.push(revData);
        }
      }
      this.chartDataTable.push(rowArr);
    });
  }

  formatSurpriseColData(surpriseData) {
    const tooltipSurpriseColData = {};
    const seriesArr = [];

    for (const currentSource in surpriseData.data) {
      const surprise = [];
      const actualData = [];
      const preqData = [];
      let nullCounter = 0;
      for (let i = 0; i < surpriseData.x.length; i++) {
        const currentVal = surpriseData.data[currentSource].surprise_data[i];
        if (currentVal.length === 0) {
          surprise.push(null);
          nullCounter++;
          continue;
        }
        if (currentVal[1] > 100) surprise.push(105);
        else if (currentVal[1] < -100) surprise.push(-105);
        else if (
          (currentVal[3] === null || parseInt(currentVal[3]) === 0) &&
          parseInt(currentVal[2]) !== 0
        ) {
          surprise.push(null);
          nullCounter++;
        } else surprise.push(currentVal[1]);

        actualData.push(currentVal[2]);
        preqData.push(currentVal[3]);
        if (!tooltipSurpriseColData[surpriseData.x[i]])
          tooltipSurpriseColData[surpriseData.x[i]] = {};
        tooltipSurpriseColData[surpriseData.x[i]][currentSource] = {
          date: currentVal[0],
          expected: Highcharts.numberFormat(currentVal[3], 2, ".", ","),
          actual: Highcharts.numberFormat(currentVal[2], 2, ".", ","),
          surprise: currentVal[1],
        };
      }
      const series = {
        name: currentSource,
        data: surprise,
      };
      if (surpriseData.x.length === nullCounter) {
        series.name = `${currentSource}(data unavailable)`;
      } else {
        seriesArr.push(series);
      }
    }
    return seriesArr;
  }

  createSurpriseTableData(mainData, seriesData) {
    if (mainData.x.length) {
      const surpriseDataObj = mainData.data;
      const unitSymbol = mainData.unit === "%" ? "bps" : "%";
      // var setPercent = scope.currency == '' && scope.unit == '%';
      // var currency = setPercent === true ? scope.unit : scope.currency;

      const actualObj = [];
      const finalRowObj = [];
      for (const key in surpriseDataObj) {
        const checkObj = seriesData.filter(function (obj) {
          return obj.name === key;
        });
        if (checkObj.length === 0) {
          continue;
        }
        const preqObj = [];
        const surpriseObj = [];
        const blankObj = [];
        const index = Object.keys(surpriseDataObj).indexOf(key);
        for (let k = 0; k < surpriseDataObj[key].surprise_data.length; k++) {
          const currentObject = surpriseDataObj[key].surprise_data[k];
          if (index === 0) {
            actualObj.push(this.tableValueFormat(currentObject[2]));
          }
          const surpriseVal = this.tableValueFormat(currentObject[1]);
          if (
            (currentObject[3] === null || currentObject[3] === 0) &&
            parseInt(currentObject[2]) !== 0
          ) {
            surpriseVal.value = "NM";
          }
          preqObj.push(this.tableValueFormat(currentObject[3]));
          surpriseObj.push(surpriseVal);
          blankObj.push({ value: undefined, class: "blankSpace" });
        }
        if (index === 0) {
          actualObj.unshift(`VA Actuals (${mainData.display_unit})`);
        }
        preqObj.unshift(`${key} Preq (${mainData.display_unit})`);
        surpriseObj.unshift(`Surprise (${unitSymbol})`);
        blankObj.unshift(" ");
        finalRowObj.push(preqObj, surpriseObj);
        finalRowObj.push(blankObj);
      }
      finalRowObj.unshift(actualObj);
      this.headers = mainData.x.slice();
      // this.headers.unshift(' ');
      this.rowHeader = finalRowObj.map((rowObj) => rowObj.shift());
      // finalRowObj.shift();
      this.chartDataTable = finalRowObj;
      // this.chartDataTable.rows = this.chartDataTable.rows[0];
    }
  }
}
